import {
  SIMPLE,
  SIMPLE_COMPLETED_PROFILE,
  SIMPLE_LINK,
  SIMPLE_SECRET_WORD,
  SIMPLE_TO_GA,
} from '../../../constants/tasksTypes';
import { COMPLETED_PROFILE, tasksForSavingProductsToGA, tasksWithInternalLink } from '../../../constants/task';

export const useQuestSubType = ({ quest }) => {
  const { uid, type } = quest;

  return {
    [SIMPLE]() {
      if (tasksWithInternalLink[uid]) return SIMPLE_LINK;
      if (tasksForSavingProductsToGA[uid]) return SIMPLE_TO_GA;
      if (COMPLETED_PROFILE === uid) return SIMPLE_COMPLETED_PROFILE;
      return SIMPLE_SECRET_WORD;
    },
  }[type]?.();
};
